import React from 'react';
import PropTypes from 'prop-types';

// Shared UI Library Components
import { CardElement, SpinElement } from '@ppmcore/seven-ppm-core-shared-components-react';

// Styles
import './auth-layout.scss';

type Props = {
  cardTitle: string;
  cardCurrentStep?: string;
  cardTotalSteps?: string;
  isLoading?: boolean;
  children: React.ReactNode;
};

export const AuthLayout = ({cardTitle, cardCurrentStep, cardTotalSteps, isLoading = false, children}: Props) => {
  return (
    <div className="auth-inside">
      {isLoading && <div className={'auth-spinner'}><SpinElement fullHeight={true} /></div>}
      {!isLoading && <div className="auth-inside-item">
        <div className={'logo-section'}>
          <img className={'logo'} src={'/assets/images/logo.svg'} alt={''} />
        </div>
        <CardElement cardTitle={cardTitle} cardCurrentStep={cardCurrentStep} cardTotalSteps={cardTotalSteps}>
          {children}
        </CardElement>
      </div>}
    </div>);
}

AuthLayout.propTypes = {
  children: PropTypes.node.isRequired
};
